<template>
  <div class="fairDocuments">
    <div class="o-documentlisting">
      <h2 v-if="title">{{ title }}</h2>
      <div v-if="mode == 'past'">
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">
                  {{ $t('components.fairDocuments.table.hall') }}
                </th>
                <th class="text-left">
                  {{ $t('components.fairDocuments.table.filetype') }}
                </th>
                <th class="text-left">
                  {{ $t('components.fairDocuments.table.download') }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="document in documents"
                :key="document.dokumentId"
              >
                <td>{{ document.hall }}</td>
                <td>{{ $t('components.fairDocuments.list.header.' + document.typ) }}</td>
                <td class="downloadlink">
                  <a @click="downloadFile(document)" download target="_blank">
                    <svg class="svgicon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1500 1500">
                      <path class="cls-1" d="M624.62,1138.47h251.78c0-139.45,91.67-272.44,237.58-272.44h95.55v-228.54h-95.55c-116.21,0-227.25,58.11-227.25,202.72h-32.28V50h-206.59v790.2h-32.28c0-144.61-111.04-202.72-228.54-202.72h-95.55v228.54h95.55c145.9,0,237.58,132.99,237.58,272.44Z"/>
                      <rect class="cls-1" x="134.4" y="1247.37" width="1231.19" height="202.63"/>
                    </svg>
                    {{ document.bezeichnung }}
                  </a>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </div>
      <ul class="documentlisting__list" v-for="documentgroup in groupedDocuments" :key="documentgroup.typ" v-else>
        <li class="list__item item--title">
          <div>
            {{ $t('components.fairDocuments.list.header.' + documentgroup.typ) }}
          </div>
        </li>
        <li class="list__item" v-for="document in documentgroup.documents" :key="document.id">
          <a @click="downloadFile(document)" download target="_blank">
            <svg class="svgicon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1500 1500">
              <path class="cls-1" d="M624.62,1138.47h251.78c0-139.45,91.67-272.44,237.58-272.44h95.55v-228.54h-95.55c-116.21,0-227.25,58.11-227.25,202.72h-32.28V50h-206.59v790.2h-32.28c0-144.61-111.04-202.72-228.54-202.72h-95.55v228.54h95.55c145.9,0,237.58,132.99,237.58,272.44Z"/>
              <rect class="cls-1" x="134.4" y="1247.37" width="1231.19" height="202.63"/>
            </svg>
            {{ document.bezeichnung }}
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import ApiService from '@/services/ApiService';
import download from 'downloadjs';

export default {
  name: 'FairDocuments',
  props: {
    documents: {
      type: Array,
      default: () => []
    },
    mode: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    }
  },
  computed: {
    groupedDocuments() {
      const filtered = [
        {
          'typ':'HPLAN',
          'documents':this.documents.filter(item=>item.typ === 'HPLAN')
        },
        {
          'typ':'STSKIZZE',
          'documents':this.documents.filter(item=>item.typ === 'STSKIZZE')
        },
        {
          'typ':'BKOP',
          'documents':this.documents.filter(item=>item.typ === 'BKOP')
        }
      ]
      return filtered.filter(item=>item.documents.length>0)
    }
  },
  methods: {
    downloadFile(document) {
      ApiService.getDocumentContent(document.dokumentId).then(response => {
        download(
          'data:' + document.contentType + ';base64,' + response.data.content,
          document.bezeichnung,
          document.contentType
        )
      })
    }
  }
}
</script>
<style lang="scss">
   @import '@/assets/css/variables.scss';
  .o-documentlisting {
    table {
      border: 1px solid black !important;

      thead {
        background-color: $brand-primary;

        th {
          color: black !important;
          font-size: inherit !important;
        }
      }
    }
  }

</style>
<style lang="scss" scoped>
   @import '@/assets/css/variables.scss';
  .fairDocuments {
    margin-top: 4.5rem;


    $documentListing-margin: 2.25rem 0 !default;

    $documentlisting-list-item-border-width: 1px !default;
    $documentlisting-list-item-border-color: $brand-darkgray !default;
    $documentlisting-list-item-padding: 0.75em 0 !default;

    $documentlisting-list-item-title-padding: 0.75rem 0 !default;
    $documentlisting-list-item-title-font-size: 1rem !default;
    $documentlisting-list-item-title-font-weight: $font-weight-bold !default;

    $documentlisting-list-item-link-color: $brand-secondary !default;
    $documentlisting-list-item-link-hover-color: $brand-primary !default;
    $documentlisting-list-item-link-disabled-color: lighten(
        $brand-blue,
        15%
    ) !default;

    .svgicon {
      width: 1rem;
      height: 1rem;
      fill: currentColor;
    }

    .o-documentlisting {
      margin: $documentListing-margin;

      td.downloadlink {
        a {
            color: $documentlisting-list-item-link-color;

            &[disabled] {
              color: $documentlisting-list-item-link-disabled-color;
            }

            &:hover {
              color: $documentlisting-list-item-link-hover-color;
            }
          }
      }

      .documentlisting__title {
      }

      .documentlisting__list {
        margin: 0;
        padding: 0;
        list-style: none;

        .list__item {
          display: flex;
          justify-content: space-between;
          padding: $documentlisting-list-item-padding;
          line-height: 1;

          &.item--title {
            padding: $documentlisting-list-item-title-padding;
            font-size: $documentlisting-list-item-title-font-size;
            font-weight: $documentlisting-list-item-title-font-weight;
            color: $brand-primary;
          }

          a {
            color: $documentlisting-list-item-link-color;

            &[disabled] {
              color: $documentlisting-list-item-link-disabled-color;
            }

            &:hover {
              color: $documentlisting-list-item-link-hover-color;
            }
          }

          *:last-child {
            text-align: right;
          }
        }
      }
    }
  }

  h2 {
    color: $brand-primary;
  }
</style>
